import React from 'react'
import styles from '../Multifocal/Multifocal.module.css'

const Multifocal = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSection}>
                    <img src='Images/multifocal-img.webp' alt='outdoor lifestyle of couple next to Paul Karpecki endorsement that Deseyne® lenses are not multifocal' loading="lazy" decoding="async" />
                </div>
                <div className={styles.RightSection}>
                    <div className={styles.content}>
                        {/* <h2 className={styles.heading}>“This is not a multifocal. </h2> */}
                        <p>“The Deseyne® lens represents a clear clinical advantage over multifocal designs,” said Paul Karpecki, OD, FAAO. “Its single, spherical optical zone delivers continuous focus across distances, reducing the need for patient adaptation while improving fitting success and practice efficiency.”  </p>
                        <p>- Paul Karpecki, OD, FAAO.</p>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Multifocal
